



// Cambia esto a 'false' cuando vayas a subir los cambios a scagliacons.cloud
const IS_LOCAL = false;

export const BASE_URL = IS_LOCAL 
    ? 'http://localhost:3001/api' 
    : 'https://scagliacons.cloud/api';

// Puedes agregar otras rutas si las necesitas
export const API_URLS = {
    PRODUCTOS: `${BASE_URL}/productos`,
    MOVIMIENTOS: `${BASE_URL}/movimientos`,
    DESTINOS: `${BASE_URL}/destinos`,
    ACTIVOS: `${BASE_URL}/activos`,
    PERSONAS: `${BASE_URL}/personas`,
    AUTH: `${BASE_URL}/auth/login`,
    ReportesView: `${BASE_URL}/reportes`
};


//const API_PRODUCTOS_URL = 'http://localhost:3001/api/productos';
//const API_PRODUCTOS_URL = 'https://scagliacons.cloud/api/productos';
//const API_MOVIMIENTOS_URL = 'https://scagliacons.cloud/api/movimientos';
//const API_DESTINOS_URL = 'https://scagliacons.cloud/api/destinos';